import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { Frown, Moon, Brain, ShirtIcon, HeartPulse } from 'lucide-react';
export function AgitationSection() {
  return <section className="py-16 md:py-20 bg-[#FFF8ED] px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <FadeInSection data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-4">
            Este ciclo interminable te está robando la vida.
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-5">
            <p data-id="element-6">
              Te despiertas cansado, sin importar cuántas horas hayas dormido la
              noche anterior.
            </p>
            <p data-id="element-7">
              Tu estado de ánimo es una montaña rusa constante. Te irritas
              fácilmente con tu pareja o tus hijos por cosas sin importancia.
            </p>
          </div>

          {/* Ilustración: Impacto en tu vida */}
          <div className="my-10 relative" data-id="element-8">
            <div className="grid grid-cols-2 sm:grid-cols-5 gap-4" data-id="element-9">
              {[{
              icon: Moon,
              label: 'Mal sueño',
              color: 'bg-indigo-100',
              iconColor: 'text-indigo-500',
              borderColor: 'border-indigo-200'
            }, {
              icon: Frown,
              label: 'Mal humor',
              color: 'bg-red-100',
              iconColor: 'text-red-500',
              borderColor: 'border-red-200'
            }, {
              icon: Brain,
              label: 'Niebla mental',
              color: 'bg-purple-100',
              iconColor: 'text-purple-500',
              borderColor: 'border-purple-200'
            }, {
              icon: ShirtIcon,
              label: 'Ropa apretada',
              color: 'bg-orange-100',
              iconColor: 'text-orange-500',
              borderColor: 'border-orange-200'
            }, {
              icon: HeartPulse,
              label: 'Glucosa alta',
              color: 'bg-rose-100',
              iconColor: 'text-rose-500',
              borderColor: 'border-rose-200'
            }].map((item, i) => <div key={i} className={`flex flex-col items-center p-4 rounded-xl ${item.color} border ${item.borderColor} text-center`} data-id="element-10">
                  <item.icon className={`w-10 h-10 ${item.iconColor} mb-2`} data-id="element-11" />
                  <span className="text-sm font-bold text-gray-700" data-id="element-12">
                    {item.label}
                  </span>
                </div>)}
            </div>
            <p className="text-center text-sm text-gray-500 mt-4 font-medium" data-id="element-13">
              Todo esto conectado por una sola causa invisible...
            </p>
          </div>

          <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-14">
            <p data-id="element-15">
              En el trabajo, esa pesada "niebla mental" te impide concentrarte,
              recordar detalles y rendir al máximo de tu capacidad.
            </p>
            <p data-id="element-16">
              La ropa cada vez te aprieta más, y la frustración crece cada
              mañana cuando intentas vestirte para salir.
            </p>
            <p data-id="element-17">
              Vives con el miedo silencioso y constante de que tus niveles de
              glucosa sigan subiendo sin control.
            </p>
            <p data-id="element-18">
              Temes profundamente que este descontrol termine en un diagnóstico
              de prediabetes, diabetes o algo mucho peor.
            </p>
            <p data-id="element-19">
              Sientes que estás perdiendo la batalla contra tu propio cuerpo, y
              que cada día es una lucha cuesta arriba.
            </p>
          </div>
        </FadeInSection>
      </div>
    </section>;
}